import isProtectedRoute from './isProtectedRoute';

const EXCLUDED_PATH_PREFIXES = ['/cart', '/checkout', '/sign-in'];

const isSyndecaExcludedPath = pathname => {
  if (typeof pathname !== 'string') {
    return false;
  }

  if (isProtectedRoute(pathname)) {
    return true;
  }

  const normalisedPath = pathname.endsWith('/') ? pathname : `${pathname}/`;

  return EXCLUDED_PATH_PREFIXES.some(prefix =>
    normalisedPath.startsWith(`${prefix}/`)
  );
};

export default isSyndecaExcludedPath;
